module.exports = __webpack_public_path__ + "media/applicants/open_email-711cc635.svg";